// extracted by mini-css-extract-plugin
module.exports = {"arrow-icon":"arrow-icon_arrow-icon__OMC5G","up":"arrow-icon_up__ro_2F","down":"arrow-icon_down__aAP7m","right":"arrow-icon_right__opY6c","left":"arrow-icon_left__kSDkA"};